import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

import { SignupMembershipType } from "../types";

export const upperCaseFirstLetter = (phrase: string) => {
  return phrase
    .split(" ")
    .map((word) =>
      word.replace(
        /^(\w)(\w*)$/,
        (_, p1: string, p2: string) => p1.toUpperCase() + p2.toLowerCase(),
      ),
    )
    .join(" ");
};

/**
 * Removes null and undefined properties from an object.
 *
 * @param input any object type (T)
 * @returns Same object without nil properties (Partial<T>)
 */
export const removeNilProperties = <T extends object>(input: T) =>
  omitBy<T>(input, isNil);

export const isEntitlementUser = (type: SignupMembershipType) =>
  type === SignupMembershipType.ENTITLEMENT;

export const isGen2User = (type: SignupMembershipType) =>
  type === SignupMembershipType.LEGACY;

export const isPayingUser = (type: SignupMembershipType) =>
  type === SignupMembershipType.PAYING;
